import Link from "next/link";
import RemoveFromComparison from "../RemoveFromComparison";
import AddToCompare from "../AddToCompare";

export default function TableHeader({
  projects,
  decodedSlug,
}: {
  projects: any[];
  decodedSlug: string;
}) {
  return (
    <thead>
      <tr>
        <th className="p-2 text-left sticky left-0 z-10 min-w-48 border-r border-gray-300 text-gray-800 font-bold bg-gray-50"></th>

        {projects.map((project, index) => (
          <th
            className="text-lg font-bold capitalize max-w-40 text-wrap min-w-72 border-r border-gray-300 p-3 text-gray-800"
            key={index}
          >
            <div className="flex flex-row gap-2 justify-center items-center">
              <Link href={`/project/${project.uuid}`} className="hover:text-primary">
                {project.projectName.toLowerCase()}
              </Link>
              <RemoveFromComparison
                uuidToRemove={project.uuid}
                slug={decodedSlug}
              />
            </div>
          </th>
        ))}
        {projects.length < 5 && (
          <th className="p-3 text-gray-800">
            <AddToCompare />
          </th>
        )}
      </tr>
    </thead>
  );
}
